import React from "react";
import styled from "styled-components";
import {
  HistoryMachineType,
  HISTORY_MACHINE_TYPE_FILTERS,
} from "../../constants/historyMachineTypeFilters";

interface MachineTypePillFilterProps {
  selectedMachineType: HistoryMachineType;
  onSelect: (machineType: HistoryMachineType) => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Pill = styled.button<{ $isActive: boolean }>`
  padding: 5px 16px;
  border-radius: 999px;
  border: 1.5px solid ${(props) => (props.$isActive ? "#1a56db" : "#d0d5dd")};
  background: ${(props) => (props.$isActive ? "#e8f0fe" : "#ffffff")};
  color: ${(props) => (props.$isActive ? "#1a56db" : "#555")};
  font-size: 13px;
  font-weight: ${(props) => (props.$isActive ? "600" : "400")};
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${(props) => (props.$isActive ? "#e8f0fe" : "#f5f5f5")};
    border-color: ${(props) => (props.$isActive ? "#1a56db" : "#9e9e9e")};
  }
`;

// =============================================
// Single-select pill row for filtering the
// History page by machine type.
//
// Pills are rendered from HISTORY_MACHINE_TYPE_FILTERS
// so the display labels are identical to the
// Postgres machine_type enum values.
//
// Exactly one pill is active at a time.
// Clicking the already-active pill is a no-op
// (single-select: at least one must stay selected).
// =============================================
const MachineTypePillFilter: React.FC<MachineTypePillFilterProps> = ({
  selectedMachineType,
  onSelect,
}) => {
  return (
    <Container role="group" aria-label="Filter by machine type">
      {HISTORY_MACHINE_TYPE_FILTERS.map((machineType) => {
        const isActive = machineType === selectedMachineType;

        return (
          <Pill
            key={machineType}
            $isActive={isActive}
            onClick={() => onSelect(machineType)}
            aria-pressed={isActive}
            type="button"
          >
            {machineType}
          </Pill>
        );
      })}
    </Container>
  );
};

export default MachineTypePillFilter;
